<div class="mt-5">
  <mat-vertical-stepper #stepper linear *ngIf="{appointment: appointment$ | async, employee: employee$ | async} as data"
    [(selectedIndex)]="selectedStepIndex">

    <mat-step [stepControl]="customerMatchingForm">
      <ng-template matStepLabel>Associate</ng-template>
      <form [formGroup]="customerMatchingForm" class="flex flex-col lead-matching-form">
        <div class="options-container" fxLayout.lt-sm="column" fxLayout.gt-xs="row-reverse">
          <div class="flex flex-col prospect-info-div" fxFlex="49">
            <div class="flex place-content-center place-items-center card-header-container">
              <div class="flex flex-row place-content-start place-items-start title-container">
                <span class="mat-body-2">Customer/Vehicle Information</span>
              </div>
            </div>
            <mat-divider></mat-divider>
            <div class="flex flex-col card-content-container">
              <div *ngIf="data.appointment" class="flex flex-col place-content-center place-items-center">
                <div class="flex place-content-start place-items-center">
                  <span class="mat-body-1 card-line-1"> {{data.appointment.customerName}}</span>
                </div>
                <div class="flex place-content-start place-items-center">
                  <span class="secondary-text">
                    {{data.appointment.vehicleDescription}}</span>
                </div>
                <div class="flex place-content-start place-items-center">
                  <span class="secondary-text" *ngIf="data.appointment.phoneNumber; else noPhone">
                    phone number</span>
                  <ng-template #noPhone>
                    <span class="secondary-text">No phone number provided</span>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <div class="flex place-content-start place-items-start radio-div" fxFlex="49">
            <mat-radio-group class="flex flex-col" fxLayoutGap="12px" formControlName="createOrMatch" required
              (change)="autoFocusSearch($event.value)">
              <mat-radio-button [value]="0">
                Create New Associate
              </mat-radio-button>
              <mat-radio-button [value]="2">
                Search Existing Associate
              </mat-radio-button>
              <mat-radio-button [value]="1">
                Select Matched Associate
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="flex flex-col content-container"
          *ngIf="customerMatchingForm.get('createOrMatch').value === 1; else matchExistingAssociates">
          <div class="loading-container" *ngIf="isLoading$ | async;">
            <div class="loading">Loading</div>
          </div>
          <div class="flex flex-col" *ngIf="associates$ | async as associates"
            [class.disabled]="customerMatchingForm.get('createOrMatch').value === 0">
            <ng-container *ngIf="associates.length > 0; else noMatchesFound">
              <div class="flex flex-row place-content-start place-content-center">
                <span class="mat-body-2">Existing Associates</span>
              </div>
              <span class="mat-caption padding-bottom-8">Select an existing associate to match with. Closest matches
                are displayed first.</span>
              <div class="flex flex-row flex-wrap place-content-start place-items-start results-inner-container">
                <ng-container *ngIf="associates$ | async as associates">
                  <crm-associate-card fxFlex="49" fxFlex.gt-md="49" fxFlex.xs="100" *ngFor="let associate of associates"
                    [associate]="associate" (click)="matchAssociate(associate, stepper)"
                    [selected]="selectedAssociate?.id === associate.id"></crm-associate-card>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #noMatchesFound>
              <div class="flex loading-container">
                <span class="mat-body-2">No Matches Found</span>
              </div>
            </ng-template>
          </div>
        </div>
        <ng-template #matchExistingAssociates>
          <div class="flex flex-col content-container"
            *ngIf="customerMatchingForm.get('createOrMatch').value === 2; else createNewAssociate">
            <mat-form-field>
              <input #associateSearch matInput autocomplete="off"
                placeholder="Associate Search (name, email, phone #, address, etc)" aria-label="Search"
                formControlName="search">
            </mat-form-field>
            <div class="loading-container" *ngIf="isLoadingExistingAssociates$ | async">
              <div class="loading">Loading</div>
            </div>
            <div class="flex flex-col" *ngIf="existingAssociateMatches$ | async as existingAssociateMatches">
              <ng-container *ngIf="existingAssociateMatches.length > 0">
                <div class="flex flex-row place-content-start place-items-center">
                  <span class="mat-body-2">Existing Associates</span>
                </div>
                <span class="mat-caption padding-bottom-8">Select an existing associate to match with.</span>
                <div class="flex flex-row flex-wrap place-content-start place-items-start results-inner-container">
                  <ng-container *ngIf="existingAssociateMatches$ | async as existingAssociateMatches">
                    <crm-associate-card fxFlex="49" fxFlex.gt-md="49" fxFlex.xs="100"
                      *ngFor="let existingAssociate of existingAssociateMatches" [associate]="existingAssociate"
                      (click)="matchAssociate(existingAssociate, stepper)"
                      [selected]="selectedAssociate?.id === existingAssociate.id"></crm-associate-card>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
          <ng-template #createNewAssociate>
            <div class="flex flex-col content-container">
              <sha-create-associate-address [associate]="newAssociate" [address]="newAddress"
                [associateDropdowns$]="serviceLaneDropdownFacade.associateDropdowns$"
                [addressDropdowns$]="serviceLaneDropdownFacade.addressDropdowns$"
                (resourcesEmitted)="newAssociateResources($event)">
                ></sha-create-associate-address>
            </div>
          </ng-template>
        </ng-template>
        <div>
          <button mat-button color="primary" matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="vehicleMatchingForm">

      <ng-template matStepLabel>Vehicle</ng-template>
      <form *ngIf="selectedAssociate" [formGroup]="vehicleMatchingForm"
        class="flex flex-col place-content-start place-items-start lead-matching-form">
        <div class="options-container" fxLayout.lt-sm="column" fxLayout.gt-xs="row-reverse">
          <div class="flex place-content-start place-items-start radio-div" fxFlex>
            <mat-radio-group class="flex flex-col" fxLayoutGap="12px" formControlName="createOrMatch" required
              (change)="autoFocusSearch($event.value)">
              <mat-radio-button [value]="0">
                Create New Vehicle
              </mat-radio-button>
              <mat-radio-button [value]="1">
                Select Matched Customer Vehicle
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="flex flex-col content-container"
          *ngIf="vehicleMatchingForm.get('createOrMatch').value === 1; else createVehicle">
          <div class="loading-container" *ngIf="isLoadingVehicle$ | async;">
            <div class="loading">Loading</div>
          </div>
          <div class="flex flex-col" *ngIf="vehicles$ | async as vehicles"
            [class.disabled]="vehicleMatchingForm.get('createOrMatch').value === 0">
            <ng-container *ngIf="vehicles.length > 0; else noMatchesFound">
              <div class="flex flex-row place-content-start place-items-center">
                <span class="mat-body-2">Existing Vehicles</span>
              </div>
              <span class="mat-caption padding-bottom-8">Select an existing vehicle to match with. Closest matches
                are displayed first.</span>
              <div class="flex flex-row flex-wrap place-content-start place-items-start results-inner-container">
                <ng-container>
                  <svc-vehicle-match-card fxFlex="49" fxFlex.gt-md="49" fxFlex.xs="100"
                    *ngFor="let vehicleObj of vehicles | addFreeformMatchingScoreToVehicles: data.appointment.vehicleDescription | orderBy:['-metaData.freeFormScore']"
                    [vehicle]="vehicleObj.vehicle" (click)="matchVehicle(vehicleObj.vehicle, stepper)"
                    [selected]="selectedVehicle?.id === vehicleObj.vehicle.id">
                  </svc-vehicle-match-card>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #noMatchesFound>
              <div class="loading-container">
                <span class="mat-body-2">No Matches Found</span>
              </div>
            </ng-template>
          </div>
        </div>
        <ng-template #createVehicle>
          <sha-create-vehicle [vehicle]="newVehicle" [vehicleDropdowns$]="serviceLaneDropdownFacade.vehicleDropdowns$"
            (formValidity)="newVehicleFormValidity($event)" (vehicleEmitted)="vehicleEmitted($event)">
          </sha-create-vehicle>
        </ng-template>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="matchingForm">
      <ng-template matStepLabel>Confirm</ng-template>
      <div class="flex flex-col" *ngIf="data.appointment && selectedAssociate && selectedVehicle">
        <svc-appointment-match-summary [appointment]="data.appointment" [associate]="selectedAssociate"
          [vehicle]="selectedVehicle"></svc-appointment-match-summary>
        <div class="flex flex-row place-content-center place-items-center m-4">
          <button mat-raised-button color="primary"
            (click)="confirmMatch(data.appointment, data.employee)">Match</button>
        </div>
      </div>
    </mat-step>
  </mat-vertical-stepper>
</div>